import EventEmitter from 'wolfy87-eventemitter';
import { IS_SERVER } from '@/misc/constants';

const ee = IS_SERVER ? null : new EventEmitter();
export default ee;
